<div class="modal fade" id="organizationAddressFormModal" msEscClose
  (escPressed)="onCancel()"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="organizationAddressFormModalLabel">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 p-4">
        <h5 class="modal-title mb-0" id="organizationAddressFormModalLabel">
          @if (!selectedType()) {
            Add / Edit Address
          } @else if (selectedAddress()) {
            Edit {{ selectedType() }} Address
          } @else {
            Add {{ selectedType() }} Address
          }
        </h5>
      </div>
      <div class="modal-body">
        @if (!selectedType()) {
          <p class="text-muted mb-3">Select an address type to add or edit.</p>

          <div class="address-type-options">
            @for (type of [AddressTypes.Physical, AddressTypes.Mailing, AddressTypes.Billing]; track type) {
              <button type="button"
                class="card mb-2 cursor-pointer address-type-option w-100 text-start border bg-transparent p-0"
                (click)="selectType(type)">
                <div class="card-body d-flex justify-content-between align-items-center py-2">
                  <div class="d-flex align-items-center">
                    <fa-duotone-icon [icon]="addressTypeIcon(type)" secondaryOpacity="0.5" class="fs-4 me-3 text-primary"></fa-duotone-icon>
                    <div>
                      <div class="fw-semibold">{{ type }}</div>
                      @if (hasAddressOfType(type)) {
                        <small class="text-muted">Edit existing {{ type }} address</small>
                      } @else {
                        <small class="text-muted">{{ addressTypeDescription(type) }}</small>
                      }
                    </div>
                  </div>
                  <fa-duotone-icon icon="chevron-right" secondaryOpacity="0.9" class="text-muted"></fa-duotone-icon>
                </div>
              </button>
            }
          </div>
        } @else {
          <ms-organization-address-form
            [addressType]="selectedType()!"
            [existingAddress]="selectedAddress()"
            (cancelRequested)="onCancel()"
            (backRequested)="backToTypeSelection()"
            (submitted)="onAddressSubmitted($event)">
          </ms-organization-address-form>
        }
      </div>
      @if (!selectedType()) {
        <div class="modal-footer border-0 d-flex justify-content-center pb-4">
          <button type="button" class="btn btn-ms-secondary" (click)="onCancel()">
            Cancel
          </button>
        </div>
      }
    </div>
  </div>
</div>

<ms-confirmation-modal
  #addressSaveConfirmationModalRef
  modalId="organizationAddressSaveConfirmationModal"
  confirmButtonText="Save"
  cancelButtonText="Cancel"
  (confirmed)="editConfirmationModalConfirmed()"
  (cancelled)="editConfirmationModalCancelled()"
/>

<ms-confirmation-modal
  #addressLeaveConfirmationModalRef
  modalId="organizationAddressLeaveConfirmationModal"
  confirmButtonText="Leave"
  cancelButtonText="Stay"
  (confirmed)="onLeaveConfirmed()"
  (cancelled)="onLeaveCancelled()"
/>
